import * as Yup from 'yup'
import { useCallback } from 'react'

import { AcceptTermsProps } from '../../../components/forms/DeclarationForm/AcceptTerms'
import { User } from '../../../graphql/generated/graphql'
import { actions } from '../../../redux'
import { StepProps } from '../../../types'
import { useSagaTakeLeading } from '../../../hooks/useSaga'

type AcceptTermsStepProps = StepProps & {
  user: User | null
}

export const useAcceptTermsStep = (props: AcceptTermsStepProps): AcceptTermsProps => {
  const { t, dispatch, user, formValues } = props

  useSagaTakeLeading(
    actions.declaration.acceptCguSuccess,
    useCallback(() => {
      dispatch(actions.declaration.setNextStep())
    }, [dispatch])
  )

  return {
    header: {
      title: t('declaration.form.acceptTerms.header.title', {
        name: `${user?.firstName} ${user?.lastName}`,
      }),
    },
    content: {
      title: t('declaration.form.acceptTerms.content.title'),
      formikForm: {
        initialValues: {
          terms: formValues.terms,
        },
        validationSchema: Yup.object().shape({
          terms: Yup.boolean().oneOf([true], t('form.error.terms')),
        }),
        onSubmit: () => {
          dispatch(
            actions.declaration.setFormValues({
              name: 'terms',
              value: true,
            })
          )
          dispatch(actions.declaration.acceptCguRequest())
        },
        validateOnChange: true,
      },
      fields: {
        terms: {
          name: 'terms',
          label: t('declaration.form.acceptTerms.terms.label'),
          required: true,
        },
      },
      submitButton: {
        text: t('declaration.form.acceptTerms.submit.label'),
      },
    },
  }
}
